import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class ChartAccountService extends DatabaseGwService {
  URL_PATH: string = "/chart-of-accs";

}
